// extracted by mini-css-extract-plugin
module.exports = {"data":"styles_data__1PJXp"};